import React, {useContext, useRef} from "react";
import MessageContext from "../../context/MessageContext.tsx";
import {OBSTACLE} from "./VisionTool.tsx";
import {Button} from "@mantine/core";
import {UploadIcon} from "@phosphor-icons/react";


export default function AFImporter ({onParse}: {onParse: (field: number[][]) => void}) {
    const ref = useRef<HTMLInputElement>(null);
    const {success, error} = useContext(MessageContext);

    const parse = (e: React.ChangeEvent<HTMLInputElement>) => {
        let reader = new FileReader();
        let parser = new DOMParser();
        if(!e.currentTarget.files) {
            return;
        }

        reader.readAsText(e.currentTarget.files[0]);

        reader.onload = () => {
            let doc = parser.parseFromString(reader.result as string, 'text/xml');
            let layout = doc.getElementsByTagName('layout');
            let field;
            if(layout.length>0) {
                let mapped = layout[0].textContent.split('\n').map(row => row.split(''));
                field = mapped.map(row => row.map(cell => cell === 'a' ? OBSTACLE.ASTEROID : OBSTACLE.NONE));
                onParse(field);
                success('XML imported');
                return;
            }

            let fieldString = doc.getElementsByTagName('fieldString');
            if(fieldString.length>0) {
                let mapped = fieldString[0].textContent.split(/\s/).map(row => row.split(''));
                field = mapped.map(row => row.map(cell => cell === 'a' ? OBSTACLE.ASTEROID : OBSTACLE.NONE));
                onParse(field);
                success('XML imported');
                return;
            }

            error('XML export not recognized');
        }
        if(ref.current) {
            ref.current.value = '';
        }
    }

    return (
        <>
            <input type="file" ref={ref} className="hidden"  accept="text/xml" onChange={parse}/>
            <Button leftSection={<UploadIcon size={16} />} onClick={() => ref.current?.click()}>Import AF</Button>
        </>
    )
}
